import React from 'react';
import PropTypes from 'prop-types';
import './storyMixerCategory.less';

const StoryMixerCategoryView = (props) => {
    return (<span className='story-mixer-category'>
                {props.category}:
            </span>);
}

StoryMixerCategoryView.propTypes = {
    category : PropTypes.string.isRequired
}

export default StoryMixerCategoryView;



// WEBPACK FOOTER //
// ./src/react/views/storyMixer/StoryMixerCategoryView.jsx